import Crud from './crud'
import { upload_file, export_list, export_detail } from '@/commons/hpod';
import { sendErrorNotice, sendSuccessNotice, refreshResource } from '@/commons/utils';
import configs from '@/configs';
var FileSaver = require('file-saver');
import Vue from 'vue';

var crud = new Crud('quotes', 'khai báo');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        UID: '',
        Username: '',
        ProductInfo: '',
        HsCode: '',
        ImageUrl: '',
        CustomsPriceCNY: 0,
        CustomsAmountCNY: 0,
        CustomsPriceVND: 0,
        CustomsAmountVND: 0,
        ExchangeRate: 23000,
        WeightPrice: 0,
        VolumePrice: 0,
        NumberOfPack: 0,
        Weight: 0,
        Volume: 0,
        TotalAmount: 0,
        PaidAmount: 0,
        ImportTax: 0,
        VatTax: 10,
        ServiceFee: 0,
        TotalFeeAmount: 0,
        EstimateTransitPrice: 0,
        EstimateTransitAmount: 0,
        IsQuoted: false,
        Status: 0,
        ProductCapacity: '',
        ProductMaterial: '',
        PackType: '',
        ProductSize: '',
        ProductNumber: 0
    }
};

const getters = {
    ...crud.getters,
};

const actions = {
    ...crud.actions,
    import_data({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file(crud.endpoint, res => {
            commit("setLoading", { loading: false });
            if(res.status == 202) {
                sendErrorNotice(res.data.reason);
            }
            else {
                refreshResource();
                sendSuccessNotice('Import file thành công.');
            }
        }, Vue.http, formData, this.state.authentication.token, 'import');
    },
    getProductSuggestions({ commit }, productInfo) {
        return new Promise((resolve, reject) => {
            Vue.http.get(`${configs.API}/api/quotes/suggestions?product_info=${productInfo}`, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(response => {
                if (response.data.success) {
                    resolve(response.data.data);
                } else {
                    reject(response.data.message);
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    exportList({ commit }, param) {
        return new Promise((resolve, reject) => {
            commit("setLoading", { loading: true });
            export_list('quotes', res => {
                try {
                    var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
                    FileSaver.saveAs(blob, `DanhSachBaoGia_${new Date().getTime()}.xlsx`);
                    resolve(res);
                    commit("setLoading", { loading: false });
                } catch (error) {
                    reject(error);
                    commit("setLoading", { loading: false });
                }
            }, Vue.http, param, this.state.authentication.token, 'export_list', (error) => {
                reject(error);
            });
        });
    },
    getQuotesByCustomer({ commit }, customerId) {
        return new Promise((resolve, reject) => {
            if (!customerId) {
                resolve([]);
                return;
            }
            Vue.http.get(`${configs.API}/api/quotes/by-customer/${customerId}`, {
                headers: { Authorization: `Bearer ${this.state.authentication.token}` }
            }).then(response => {
                if (response.data.status === 200) {
                    resolve(response.data.data);
                } else {
                    reject(response.data.message);
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    exportDetail({ commit }, param) {
        return new Promise((resolve, reject) => {
            export_detail('quotes', res => {
                try {
                    var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
                    FileSaver.saveAs(blob, `BaoGia_${new Date().getTime()}.xlsx`);
                    resolve(res);
                } catch (error) {
                    reject(error);
                }
            }, Vue.http, param, this.state.authentication.token, 'export', (error) => {
                reject(error);
            });
        });
    }
};

const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};